import { createSelector } from 'reselect';

import { apiStatuses } from 'src/constants/taxonomy';
import type { StoreState } from 'src/store/types';
import type { Invoice } from 'src/types';

import { showInvoiceInPayable, showInvoiceInHistory } from './utils';

export const selectInvoiceBaseUri = (state: StoreState) =>
  state.invoiceApiBaseUri;

const selectInvoiceDocuments = (state: StoreState) => state.invoices;

export const selectInvoices = createSelector(
  selectInvoiceDocuments,
  (invoices: Record<string, Invoice>) =>
    Object.values(invoices)
      .filter(Boolean)
      .map((invoice) => ({
        ...invoice,
        includesTax:
          (invoice.taxPayable && invoice.taxPayable > 0) ||
          invoice.taxAmount > 0,
      })),
);

export const selectUnpaidInvoices = createSelector(selectInvoices, (invoices) =>
  invoices.filter((invoice) => showInvoiceInPayable(invoice)),
);
export const selectPaidInvoices = createSelector(selectInvoices, (invoices) =>
  invoices.filter(showInvoiceInHistory),
);

export const selectInvoicesLoading = (state: StoreState) =>
  Boolean(state.invoicesApiLoading);
export const selectInvoicesLoaded = (state: StoreState) =>
  Boolean(state.invoicesApiLoaded);

export const selectUsersLoading = (state: StoreState) =>
  state.usersApiStatus === apiStatuses.LOADING;
export const selectUsersLoaded = (state: StoreState) =>
  state.usersApiStatus === apiStatuses.LOADED;

export const selectInvoicesError = (state: StoreState) =>
  state.invoicingApiError;

export const selectLoadMoreInvoicesCursor = (state: StoreState) =>
  state.loadMoreInvoicesCursor;
